import React__default from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const PupillaryDistanceLink = ({ className , labels  })=>{
    const { pdLinkLabel  } = labels;
    if (!pdLinkLabel) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("p", {
        className: classnames('pupillary-distance-link', className)
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "glasses",
        className: "pupillary-distance-link__icon"
    }), pdLinkLabel);
};

export { PupillaryDistanceLink };
//# sourceMappingURL=PupillaryDistanceLink.js.map
